import { preloadHomeWidgets } from './preloadHomeWidgets.ts';

export const preloadSidePanel = ({ isLicensed }: { isLicensed: boolean }) => {
	return preloadHomeWidgets({ isLicensed });
};
